import { takeEvery, call, put, select, takeLeading } from 'typed-redux-saga'
import { errorHandler } from 'Modules'
import { cloneDeep, sortBy } from 'lodash'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	interfaceElementNS,
	interfaceElementSlice,
	InterfaceElementModel,
	interfaceElementsApi,
	interfaceElementsSelector,
	RoleInterfaceElementModel,
	SORT_BY_ORDER,
	isPage_403,
} from 'Pages/interfaceElement'
import { Callback } from 'Src/types/utilTypes'
import { Deserialize } from 'cerialize'
import { selectHistory } from 'Store'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'

const getInterfaceElementsTableData = (
	elems: InterfaceElementModel[] = [],
	roleElems: RoleInterfaceElementModel[],
	role_id?: number
): RoleInterfaceElementModel[] => {
	const elements = cloneDeep(elems)
	const roleElements = cloneDeep(roleElems)
	let elementsTree: RoleInterfaceElementModel[] = []

	const activeForRoleElements = roleElements.filter((role) => role.role_id === role_id)

	elements.forEach((el) => {
		el.key = el.id

		if (activeForRoleElements && activeForRoleElements.length) {
			activeForRoleElements.forEach((roleElem) => {
				el.active = { ...el.active, role_id }
				// @ts-ignore
				if (el.id === roleElem.interface_element_id) {
					el.active = { ...el.active, active: roleElem.active, roleElemId: roleElem.id }
				}
			})
		} else {
			el.active = { ...el.active, role_id }
		}
		if (!el.parent_element_id) {
			elementsTree.push(el as unknown as RoleInterfaceElementModel)
		}
	})
	elementsTree = sortBy(elementsTree, SORT_BY_ORDER)

	elements.forEach((el) => {
		elementsTree.forEach((treeElement) => {
			if (treeElement.id === el.parent_element_id) {
				el.key = el.id

				activeForRoleElements.forEach((roleElem) => {
					el.active = { ...el.active, role_id }

					// @ts-ignore
					if (el.id === roleElem.interface_element_id) {
						el.active = { ...el.active, active: roleElem.active, roleElemId: roleElem.id }
					}
				})

				treeElement.children = treeElement.children || []

				treeElement.children.push(el as unknown as RoleInterfaceElementModel)
			}
		})
	})
	return elementsTree
}

// универсальная сага для перезапроса всех прав роли
function* getRoleRequest(requestParams?: RequestParams) {
	let params
	if (requestParams) {
		params = requestParams
	} else {
		params = yield* select(interfaceElementsSelector.getRoleRequestParams)
	}
	const res = yield* call(interfaceElementsApi.getAllRole, params)
	const elems = yield* select(interfaceElementsSelector.getAll)
	const result = getInterfaceElementsTableData(
		elems.entries,
		res.entries as unknown as RoleInterfaceElementModel[],
		params.role_id
	)
	yield* put(interfaceElementSlice.actions.setAllRole(result))
	yield* put(interfaceElementSlice.actions.getInterfaceElementAvailable())
}

function* getAllItems(requestParams?: RequestParams, clear?: boolean, callback?: Callback) {
	let params = new RequestParams()
	let oldItems = new ResponseCatalog<InterfaceElementModel>()
	if (!clear && requestParams?.page !== 1) {
		oldItems = yield* select(interfaceElementsSelector.getAll)
		params = yield* select(interfaceElementsSelector.getRequestParams)
	}
	const res = yield* call(interfaceElementsApi.getAll, requestParams || params)
	const items = new ResponseCatalog<InterfaceElementModel>(res)
	const newItems = res.entries.map(
		(item): InterfaceElementModel => Deserialize(item, InterfaceElementModel)
	)
	items.entries = [...oldItems.entries, ...newItems]
	yield* put(interfaceElementSlice.actions.setAll(items))
	yield* call(getRoleRequest)
	callback?.()
}

function* getAll(action: interfaceElementNS.GetAll) {
	try {
		yield* call(
			getAllItems,
			action.payload?.params,
			action.payload?.clear,
			action.payload?.callback
		)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createOne(action: interfaceElementNS.CreateOne) {
	try {
		yield* call(interfaceElementsApi.createOne, action.payload)
		const res = yield* call(interfaceElementsApi.getAll)
		yield* put(interfaceElementSlice.actions.setAll(res))
		yield* call(getRoleRequest)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateOne(action: interfaceElementNS.UpdateOne) {
	try {
		const { interfaceElement, id } = action.payload
		yield* call(interfaceElementsApi.updateOne, interfaceElement, id)
		const res = yield* call(interfaceElementsApi.getAll)
		yield* put(interfaceElementSlice.actions.setAll(res))
		yield* call(getRoleRequest)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* deleteOne(action: interfaceElementNS.DeleteOne) {
	try {
		yield* call(interfaceElementsApi.deleteOne, action.payload)
		const res = yield* call(interfaceElementsApi.getAll)
		yield* put(interfaceElementSlice.actions.setAll(res))
		yield* call(getRoleRequest)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* getAllRole(action: interfaceElementNS.GetAllRole) {
	try {
		yield* call(getRoleRequest, action.payload)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createRoleOne(action: interfaceElementNS.CreateOneRole) {
	try {
		yield* call(interfaceElementsApi.createRole, action.payload)
		yield* call(getRoleRequest)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateRoleOne(action: interfaceElementNS.UpdateOneRole) {
	try {
		const { roleInterfaceElement, id } = action.payload
		yield* call(interfaceElementsApi.updateRole, roleInterfaceElement, id)
		yield* call(getRoleRequest)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* deleteRoleOne(action: interfaceElementNS.DeleteOneRole) {
	try {
		yield* call(interfaceElementsApi.deleteRole, action.payload)
		yield* call(getRoleRequest)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
export function* getInterfaceElementAvailable() {
	try {
		const { location } = yield* select(selectHistory)
		const res = yield* call(interfaceElementsApi.getInterfaceElementAvailable)
		yield* put(interfaceElementSlice.actions.setInterfaceElementAvailable(res.entries))
		if (isPage_403(res?.entries, location)) yield* put(routerActions.push(FrontUrls.pages.page_403))
		yield* put(interfaceElementSlice.actions.sendOpenedSectionId(window.location.pathname))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
export function* sendOpenedMenuSectionId(action: interfaceElementNS.SendOpenedSectionId) {
	try {
		const pathName = action.payload
		const openedSectionId = yield* select(interfaceElementsSelector.getOpenedSectionIdSelector)
		const menuStructure = yield* select(interfaceElementsSelector.getNavStructure)
		const compareSlashCount = (urlFromConfig, currentUrl): boolean => {
			return currentUrl.match(/\//g).length >= urlFromConfig.match(/\//g).length
		}
		const currentMenuStructureItem =
			pathName.length > 1 &&
			menuStructure.find(
				({ url }): boolean => url.indexOf(pathName) === 0 && compareSlashCount(url, pathName)
			)
		let sectionId = null
		if (currentMenuStructureItem !== undefined) {
			sectionId = currentMenuStructureItem?.id
			if (openedSectionId === null && !!sectionId) {
				yield* put(interfaceElementSlice.actions.setOpenedSectionId(sectionId))
				yield* call(interfaceElementsApi.sendMenuSectionId, sectionId)
				return false
			}
			if (!!sectionId && sectionId !== openedSectionId) {
				yield* put(interfaceElementSlice.actions.setOpenedSectionId(sectionId))
				yield* call(interfaceElementsApi.sendMenuSectionId, sectionId)
			}
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const interfaceElementSaga = function* saga() {
	yield* takeEvery(interfaceElementSlice.actions.getAll.type, getAll)
	yield* takeEvery(interfaceElementSlice.actions.createOne.type, createOne)
	yield* takeEvery(interfaceElementSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(interfaceElementSlice.actions.deleteOne.type, deleteOne)
	yield* takeEvery(interfaceElementSlice.actions.getAllRole.type, getAllRole)
	yield* takeEvery(interfaceElementSlice.actions.createOneRole.type, createRoleOne)
	yield* takeEvery(interfaceElementSlice.actions.updateOneRole.type, updateRoleOne)
	yield* takeEvery(interfaceElementSlice.actions.deleteOneRole.type, deleteRoleOne)
	yield* takeLeading(
		interfaceElementSlice.actions.getInterfaceElementAvailable.type,
		getInterfaceElementAvailable
	)
	yield* takeEvery(interfaceElementSlice.actions.sendOpenedSectionId.type, sendOpenedMenuSectionId)
}
